import React from "react";
import {
  ChakraProvider,
  Flex,
  Text,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useMediaQuery,
  SimpleGrid,
  HStack,
  Box,
  useDisclosure,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton
} from "@chakra-ui/react";

export default function Mytasks() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLargerThan1240] = useMediaQuery("(min-width: 1240px)");
  const [menuButtonTitle, setMenuButtonTitle] = React.useState("Most Recent");

  const [finishedTask, setFinishedTask] = React.useState(false);
  return (
    <ChakraProvider>
      <Flex flexDirection="column" justifyContent="center" alignItems="center">
        <Flex>
          <Button
            onClick={() => {
              setFinishedTask(!finishedTask);
            }}
          >
            Show Finished Tasks/ Hide
          </Button>
        </Flex>
        <Flex width={isLargerThan1240 ? "1200px" : "97vw"}>
          <Text fontWeight="bold" fontSize="26">
            My Tasks
          </Text>
        </Flex>

        <Flex
          width={isLargerThan1240 ? "1200px" : "97vw"}
          justifyContent="space-between"
          alignItems="center"
        >
          <Text fontSize="15">4 Tasks Submitted</Text>
          <Menu>
            <MenuButton as={Button}>Sort by / {menuButtonTitle}</MenuButton>
            <MenuList>
              <MenuItem
                onClick={() => {
                  setMenuButtonTitle("Most Recent");
                }}
              >
                Most Recent
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setMenuButtonTitle("Highest Paying");
                }}
              >
                Highest Paying
              </MenuItem>
            </MenuList>
          </Menu>
        </Flex>
        <Flex
          my="4"
          // bg={"purple.400"}
          width={isLargerThan1240 ? "1200px" : "97vw"}
          justifyContent="center"
        >
          <Flex
            display={finishedTask ? "none" : "flex"}
            width="full"
            borderWidth="2px"
            borderRadius="lg"
            p="4"
            _hover={{
              transform: "translateY(-2px)",
              boxShadow: "lg"
            }}
            cursor="pointer"
          >
            <Text width="full" textAlign="center">
              Don't finished any task yet.
            </Text>
          </Flex>
        </Flex>

        <Flex
          display={finishedTask ? "flex" : "none"}
          width={isLargerThan1240 ? "1200px" : "97vw"}
          flexDirection="column"
        >
          <Flex
            mt="4"
            width="full"
            borderWidth="2px"
            borderRadius="lg"
            p="4"
            justifyContent="space-between"
          >
            <SimpleGrid columns="2" spacing="70px">
              <Text>Status</Text>
              <Text>Job Name</Text>
            </SimpleGrid>
            <SimpleGrid columns="1" spacing="70px">
              <Text>Earned</Text>
            </SimpleGrid>
          </Flex>
          <Flex
            mt="1"
            width="full"
            borderWidth="2px"
            borderRadius="lg"
            p="4"
            _hover={{
              transform: "translateY(-2px)",
              boxShadow: "lg"
            }}
            cursor="pointer"
            justifyContent="space-between"
            onClick={onOpen}
          >
            <Flex alignItems="center">
              <SimpleGrid columns="1">
                <Text
                  bg="red.500" // blue = finished, black = admin review, red = rejected, yellow = pending.
                  color="white"
                  fontWeight="semibold"
                  p="5px"
                  borderRadius="sm"
                  width="80px"
                  height="35px"
                  textAlign="center"
                >
                  Rejected
                </Text>
              </SimpleGrid>
              <SimpleGrid columns="1" alignItems="center">
                <Text ms="60px">
                  Reddit: Vote up Reddit: Vote up Reddit: Vote up hgc...
                </Text>
              </SimpleGrid>
            </Flex>
            <SimpleGrid columns="1" alignItems="center">
              <Text textAlign="center" width="51px" fontWeight="bold">
                0.23$
              </Text>
            </SimpleGrid>
          </Flex>

          <Flex
            mt="1"
            width="full"
            borderWidth="2px"
            borderRadius="lg"
            p="4"
            _hover={{
              transform: "translateY(-2px)",
              boxShadow: "lg"
            }}
            cursor="pointer"
            justifyContent="space-between"
          >
            <Flex alignItems="center">
              <SimpleGrid columns="1">
                <Text
                  bg="green.600" // blue = finished, black = admin review, red = rejected, yellow = pending.
                  color="white"
                  fontWeight="semibold"
                  p="5px"
                  borderRadius="sm"
                  width="80px"
                  height="35px"
                  textAlign="center"
                >
                  Approve
                </Text>
              </SimpleGrid>
              <SimpleGrid columns="1" alignItems="center">
                <Text ms="60px">
                  Reddit: Vote up Reddit: Vote up Reddit: Vote up hgc...
                </Text>
              </SimpleGrid>
            </Flex>
            <SimpleGrid columns="1" alignItems="center">
              <Text textAlign="center" width="51px" fontWeight="bold">
                0.23$
              </Text>
            </SimpleGrid>
          </Flex>
          <Flex
            mt="1"
            width="full"
            borderWidth="2px"
            borderRadius="lg"
            p="4"
            _hover={{
              transform: "translateY(-2px)",
              boxShadow: "lg"
            }}
            cursor="pointer"
            justifyContent="space-between"
          >
            <Flex alignItems="center">
              <SimpleGrid columns="1">
                <Text
                  bg="yellow.500" // blue = finished, black = admin review, red = rejected, yellow = pending.
                  color="white"
                  fontWeight="semibold"
                  p="5px"
                  borderRadius="sm"
                  width="80px"
                  height="35px"
                  textAlign="center"
                >
                  Pending
                </Text>
              </SimpleGrid>
              <SimpleGrid columns="1" alignItems="center">
                <Text ms="60px">
                  Reddit: Vote up Reddit: Vote up Reddit: Vote up hgc...
                </Text>
              </SimpleGrid>
            </Flex>
            <SimpleGrid columns="1" alignItems="center">
              <Text textAlign="center" width="51px" fontWeight="bold">
                0.23$
              </Text>
            </SimpleGrid>
          </Flex>
        </Flex>
        <Flex>
          <Button
            colorScheme="blue"
            onClick={() => {
              window.open("/main", "_top");
            }}
          >
            Find Job
          </Button>
        </Flex>

        <Drawer placement="right" onClose={onClose} isOpen={isOpen}>
          <DrawerOverlay />
          <DrawerContent>
            <DrawerHeader borderBottomWidth="1px">Basic Drawer</DrawerHeader>
            <DrawerBody>
              <p>Some contents...</p>
              <p>Some contents...</p>
              <p>Some contents...</p>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
        {/* <Flex>
          <Flex bg={"pink"} width="85vw">
            List Item
          </Flex>
        </Flex> */}
      </Flex>
    </ChakraProvider>
  );
}
